import { jsxs as w, jsx as s } from "react/jsx-runtime";
import { u as o } from "./index-6a632112.mjs";
import { useState as O, useRef as y, useEffect as T } from "react";
import { CloseButton as gt } from "./closeButton.js";
import { Button as ht } from "./button.js";
import { Q as d, d as _, a as F, e as N, s as l, r as I, l as vt, f as xt } from "./themes-5f0b3c3d.mjs";
import { l as X } from "./lineHeights-72d3110c.mjs";
import { useAccessibilityProps as U } from "./accessibility.js";
import { useWindowDimensions as $t } from "./useWindowDimensions.js";
import { g as V } from "./getElementPosition-5026bb28.mjs";
import "./cancelClose-87fdf326.mjs";
import "./types-b577bf77.mjs";
import "./iconButton.js";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./zIndices-d07533f3.mjs";
const Z = 5, yt = () => ` 
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;`;
function wt(t) {
  return t === "top" || t === "bottom" || t === "auto" ? "translate(-50%)" : t === "top-start" || t === "bottom-start" ? "translate(-100%)" : t === "top-end" || t === "bottom-end" ? "translate(5%)" : t === "right-start" || t === "left-start" ? "translate(0, -90%)" : t === "right-end" || t === "left-end" ? "translate(0, -10%)" : t === "right" || t === "left" ? "translate(0, -50%)" : null;
}
function kt(t) {
  return t === "top" || t === "bottom" ? "translate(-50%, -8px)" : t === "left" ? "translate(8px, -50%)" : t === "right" ? "translate(-8px, -50%)" : null;
}
const G = o.span`
  --pointer-size: calc(${Z} / 16 * 1rem);
  --border-color: ${(t) => t.theme.components.popover.borderColor};
  --border-size: 1px;
  --background-color: ${(t) => t.theme.components.popover.backgroundColor};
`, c = o(G)`
  position: absolute;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;

  &::after,
  &::before {
    border: solid transparent;
    border-color: transparent;
    content: '';
    height: 0;
    width: 0;
    position: absolute;
  }

  &::after {
    border-top-color: var(--background-color);
    border-width: var(--pointer-size);
    margin-left: calc(var(--pointer-size) * -1);
  }

  &::before {
    border-top-color: var(--border-color);
    border-width: calc(var(--pointer-size) + var(--border-size));
    margin-left: calc((var(--pointer-size) + var(--border-size)) * -1);
  }

  @media ${d.mobile} {
    display: none;
  }
`, zt = o(c)`
  top: 100%;
  left: 50%;
  transform: translateY(calc(var(--border-size) * -1));
`, Pt = o(c)`
  bottom: 100%;
  left: 50%;
  transform: rotate(180deg) translateY(calc(var(--border-size) * -1));
`, St = o(c)`
  left: 100%;
  top: 50%;
  transform: rotate(270deg) translateY(calc(var(--border-size) * -1));
`, Ct = o(c)`
  right: 100%;
  top: 50%;
  transform: rotate(90deg) translateY(calc(var(--border-size) * -1));
`, Et = o(c)`
  top: 100%;
  left: 10%;
  transform: translateY(calc(var(--border-size) * -1));
`, Bt = o(c)`
  top: 100%;
  left: 85%;
  transform: translateY(calc(var(--border-size) * -1));
`, Rt = o(c)`
  right: 100%;
  top: 15%;
  transform: rotate(90deg) translateY(calc(var(--border-size) * -1));
`, Lt = o(c)`
  right: 100%;
  top: 85%;
  transform: rotate(90deg) translateY(calc(var(--border-size) * -1));
`, Wt = o(c)`
  bottom: 100%;
  left: 10%;
  transform: rotate(180deg) translateY(calc(var(--border-size) * -1));
`, Ot = o(c)`
  bottom: 100%;
  left: 85%;
  transform: rotate(180deg) translateY(calc(var(--border-size) * -1));
`, Tt = o(c)`
  left: 100%;
  top: 15%;
  transform: rotate(270deg) translateY(calc(var(--border-size) * -1));
`, Yt = o(c)`
  left: 100%;
  top: 85%;
  transform: rotate(270deg) translateY(calc(var(--border-size) * -1));
`, Dt = o.p`
  ${yt()}
  font-family: ${_.eyebrow};
  color: ${(t) => t.theme.components.popover.titleColor};
  font-size: ${F.small};
  font-style: normal;
  font-weight: ${N.medium.M.fontWeight};
  line-height: ${X.medium};
  text-align: left;
  overflow: hidden;
`, At = o.div`
  font-family: ${_.eyebrow};
  font-size: ${F.xsmall};
  font-style: normal;
  font-weight: ${N.regular.S.fontWeight};
  line-height: ${X.small};
  max-height: 20vh;
  word-break: break-word;
  text-align: left;
  white-space: normal;
  padding: 0px ${l["2x"]} 0px ${l["3x"]};
  margin-right: ${l["2x"]};

  color: ${(t) => t.theme.components.popover.textColor};
  overflow: auto;

  @media ${d.mobile} {
    max-height: 100%;
  }

  &::-webkit-scrollbar {
    width: ${l["2x"]};
    height: ${l["1x"]};
  }

  &::-webkit-scrollbar-corner {
    background: rgba(0, 0, 0, 0);
  }

  &::-webkit-scrollbar-thumb {
    background-color: #9ca3ad;
    border-radius: ${I["2x"]};
    transform: translateX(calc(100% - 10px));
  }

  &::-webkit-scrollbar-track {
    background-color: #e6e8ea;
    border-radius: ${I["2x"]};
  }
`, jt = o.div`
  display: flex;
  width: 100%;
  gap: ${l["1x"]};
  flex-direction: row;
  justify-content: space-between;
  white-space: normal;
  word-wrap: break-word;
  align-items: center;
  box-sizing: border-box;
  padding: 0px ${l["3x"]} 0px ${l["3x"]};

  @media ${d.mobile} {
    width: 100%;
  }
  button {
    align-self: flex-start;
  }
`, It = o(G)`
  width: 1px;
  height: calc(var(--pointer-size) * 2);
  display: inline-block;
  position: absolute;
  top: calc(var(--pointer-size) * -1);
  right: calc(var(--border-size) / 2);
  z-index: 1;
  transform: rotate(90deg);
  background: var(--background-color);
`, Ft = o.div`
  width: 240px;
  background-color: ${(t) => t.theme.components.popover.backgroundColor};
  border: 1px solid ${(t) => t.theme.components.popover.borderColor};
  position: relative;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  white-space: nowrap;
  padding: ${l["2x"]} 0px ${l["3x"]} 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: calc((14 / 16) * 1rem);
  font-family: ${(t) => t.theme.typography.primaryFont};
  box-sizing: border-box;
  letter-spacing: ${vt[0]};
  line-height: calc((20 / 16) * 1rem);
  text-align: center;
  display: flex;
  gap: 8px;
  flex-direction: column;
  @media ${d.mobile} {
    width: 100%;
  }
  border-radius: ${I["1x"]};
`, E = o.div`
  position: ${(t) => t.$exceedOverflow ? "fixed" : "absolute"};
  z-index: 116;
  display: var(--display);
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  --pointer-gap: ${(t) => t.$exceedOverflow ? "unset" : `calc(${Z}px + (18 / 16 * 1rem))`};
  @media ${d.mobile} {
    display: flex;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform: none;
    left: 0;
  }

  display: ${({ $isOpen: t }) => t ? "block" : "none"};
  --translate: ${({ $isOpen: t, $position: r }) => t ? wt(r) : kt(r)};
`, Ht = o.div`
  position: relative;
  display: inline-flex;

  ul,
  ol {
    padding-left: unset;
  }
`, Mt = o.div`
  padding: ${l["1x"]} ${l["3x"]} 0px ${l["3x"]};
  display: flex;
  justify-self: center;
  align-items: center;

  button {
    width: 100%;
  }
`, qt = o.div`
  @media ${d.mobile} {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }
`, Y = o(E)`
  left: 50%;
  bottom: calc(100% + var(--pointer-gap));
  transform: var(--translate);
  @media ${d.mobile} {
    transform: translate(-50%);
  }
`, D = o(E)`
  left: 50%;
  top: calc(100% + var(--pointer-gap));
  transform: var(--translate);
  @media ${d.mobile} {
    top: unset;
    transform: translate(-50%, 0%);
  }
`, A = o(E)`
  top: 50%;
  right: calc(100% + var(--pointer-gap));
  transform: var(--translate);
  @media ${d.mobile} {
    transform: translate(0, -50%);
  }
`, j = o(E)`
  top: 50%;
  left: calc(100% + var(--pointer-gap));
  transform: var(--translate);
  @media ${d.mobile} {
    transform: translate(0, -50%);
    left: unset;
  }
`, Kt = o.hr`
  border-top: 1px solid;
  left: calc(-50vw + 50%);
  color: ${(t) => t.theme.components.popover.dividerColor};
  position: relative;
  width: 100vw;

  margin: unset;
`, Qt = o.span`
  display: inline-flex;
  cursor: pointer;

  &:focus-visible {
    outline: 3px solid ${(t) => t.theme.colors.primaryHoverColor};
    outline-offset: 2px;
  }
`;
function fe({
  children: t,
  placement: r = "auto",
  popupTipHeader: k,
  popupTipBody: J,
  className: tt,
  style: et,
  CTAButtonHandler: ot,
  CTAbuttonLabel: rt = "Button",
  showButton: nt = !0,
  accessibilityOptions: it = {
    closeButton: {
      ariaLabel: "CloseButton"
    }
  },
  showTitleBorder: at = !0,
  exceedOverflow: v = !1,
  ...st
}) {
  const [p, B] = O(!1), H = y(null), z = y(null), g = y(null), R = y(null), [n, m] = O(r), P = y(null), [lt, M] = O({}), { width: u, height: b } = $t(), { CTAButton: ct, closeButton: pt } = it, ft = U("button", {
    ...ct
  }), dt = U("button", {
    ...pt
  });
  let i, a;
  const L = () => {
    if (m("top"), !g?.current)
      return;
    const e = g.current.getBoundingClientRect(), f = e.top < 0, S = e.bottom > b - 1, x = e.right > u - 1, $ = e.left < 0, C = e.top < 0 && e.right > u - 1, h = f && $, W = e.bottom + 100 > b - 1 && $, Q = e.bottom + 100 > b - 1 && x;
    f && m("bottom"), x && m("left"), S && m("top"), $ && m("right"), C && m("bottom-start"), h && m("bottom-end"), W && m("top-end"), Q && m("top-start");
  }, mt = () => {
    v || (r === "auto" ? L() : r.startsWith("top") || r.startsWith("bottom") ? ut() : (r.startsWith("left") || r.startsWith("right")) && bt());
  }, ut = () => {
    if (g.current) {
      const e = g.current.getBoundingClientRect();
      (e.left < 0 || e.top < 0 || e.right > u - 1 || e.top < 0 && e.left < 0 || e.top < 0 && e.right > u - 1 || e.bottom > b - 1 || e.bottom + 100 > b - 1 && e.left < 0 || e.bottom + 100 > b - 1 && e.right > u - 1) && L();
    }
  }, bt = () => {
    if (g.current) {
      const e = g.current.getBoundingClientRect();
      (e.top < 0 || e.left < 0 || e.top < 0 && e.left < 0 || e.bottom > b - 1 || e.right > u - 1 || e.top < 0 && e.right > u - 1 || e.bottom + 100 > b - 1 && e.right > u - 1) && L();
    }
  };
  if (T(() => {
    v || mt();
    const e = document.getElementById("popuptip");
    e?.setAttribute("tabindex", "-1"), e?.focus();
    const f = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', S = e?.querySelectorAll(
      f
    )[0], x = e?.querySelectorAll(f), $ = x && x[x.length - 1], C = (h) => {
      const W = h.key === "Tab";
      h.key === "Escape" && K(), W && (h.shiftKey ? document.activeElement === S && ($?.focus(), h.preventDefault()) : document.activeElement === $ && (S?.focus(), h.preventDefault()));
    };
    return p && document.addEventListener("keydown", C), () => {
      document.removeEventListener("keydown", C);
    };
  }, [p]), n === "top" || n === "auto")
    i = zt, a = Y;
  else if (n === "top-end")
    i = Et, a = Y;
  else if (n === "top-start")
    i = Bt, a = Y;
  else if (n === "left")
    i = St, a = A;
  else if (n === "left-start")
    i = Yt, a = A;
  else if (n === "left-end")
    i = Tt, a = A;
  else if (n === "right")
    i = Ct, a = j;
  else if (n === "right-start")
    i = Lt, a = j;
  else if (n === "right-end")
    i = Rt, a = j;
  else if (n === "bottom")
    i = Pt, a = D;
  else if (n === "bottom-start")
    i = Ot, a = D;
  else if (n === "bottom-end")
    i = Wt, a = D;
  else
    throw new Error(`Unrecognized Popuptip placement: ${n}`);
  const q = () => {
    B((e) => !e);
  }, K = () => {
    B(!p), P.current?.focus();
  };
  return T(() => {
    const e = (f) => {
      z.current && !z.current.contains(f.target) && B(!1);
    };
    return p ? (z.current = H.current, document.addEventListener("mousedown", e)) : (z.current = null, document.removeEventListener("mousedown", e)), () => {
      document.removeEventListener("mousedown", e);
    };
  }, [p]), T(() => {
    if (p && v) {
      const e = r === "auto" || !r ? "top" : r;
      M(
        V(P, R, e, "popuptip")
      );
      const f = () => {
        M(
          V(P, R, e, "popuptip")
        );
      };
      return window.addEventListener("scroll", f, !0), () => {
        window.removeEventListener("scroll", f, !0);
      };
    }
  }, [p, r, v, u, b]), /* @__PURE__ */ w(Ht, { ref: H, ...st, children: [
    /* @__PURE__ */ s(
      Qt,
      {
        onClick: q,
        ref: P,
        tabIndex: 0,
        onKeyDown: (e) => {
          (e.key === "Enter" || e.key === " ") && q();
        },
        children: t
      }
    ),
    p && /* @__PURE__ */ s(qt, { children: /* @__PURE__ */ w(
      a,
      {
        id: "popuptip",
        role: "dialog",
        "aria-hidden": !p,
        "aria-label": k,
        ref: g,
        $isOpen: p,
        $position: n,
        style: v ? lt : {},
        $exceedOverflow: v,
        children: [
          /* @__PURE__ */ w(Ft, { className: tt, style: et, ref: R, children: [
            /* @__PURE__ */ w(jt, { children: [
              /* @__PURE__ */ s(Dt, { children: k }),
              /* @__PURE__ */ s(
                gt,
                {
                  onClick: K,
                  size: "xsmall",
                  ...dt
                }
              )
            ] }),
            at && /* @__PURE__ */ s(Kt, {}),
            /* @__PURE__ */ s(At, { children: J }),
            nt && /* @__PURE__ */ s(Mt, { children: /* @__PURE__ */ s(
              ht,
              {
                size: "small",
                variant: "solid",
                ...ft,
                onClick: ot,
                children: rt
              }
            ) })
          ] }),
          /* @__PURE__ */ s(i, { children: /* @__PURE__ */ s(It, {}) })
        ]
      }
    ) })
  ] });
}
const Ut = o.div`
  position: relative;
  display: inline-flex;
  padding: 12px;
`, Vt = o.a`
  font-family: ${xt.inter};
  font-size: ${F.xsmall};
  color: ${(t) => t.theme.components.popover.linkColor};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`, _t = o.span`
  margin: 0 0.5rem;
  color: ${(t) => t.theme.components.popover.linkDividerColor};
`, de = ({ links: t }) => /* @__PURE__ */ s(Ut, { children: t.map((r, k) => /* @__PURE__ */ w("div", { children: [
  /* @__PURE__ */ s(Vt, { href: r.url, target: "_blank", rel: "noopener noreferrer", children: r.title }),
  k !== t.length - 1 && /* @__PURE__ */ s(_t, { children: " | " })
] }, r.id)) });
export {
  fe as PopupTip,
  de as PopupTipLinks
};
